import { getSite } from "_foundationExt/hooks";

export const determineStoreId = (paramStoreId?: string) => {
  if (paramStoreId) {
    return paramStoreId;
  }
  const site = getSite();
  return site?.storeID;
};
